import React from 'react';
import PropTypes from 'prop-types';

import useChart from '../../../hooks/useChart';
import { titleOptions, GreyColors } from '../../../shared/chart-options';
import { LineupTooltip } from './LineupTooltip';

const OPTIONS = {
  color: GreyColors.color,
  grid: {
    top: 35,
    bottom: 5,
    left: 30,
    right: 0,
  },
  xAxis: {
    type: 'category',
    axisLine: GreyColors.axisLine,
  },
  yAxis: {
    type: 'value',
    axisLabel: GreyColors.axisLabel,
    axisLine: GreyColors.axisLine,
    axisTick: { lineStyle: GreyColors.lineStyle },
    splitLine: { lineStyle: GreyColors.splitLine },
  },
  tooltip: {
    show: true,
    formatter: LineupTooltip,
    textStyle: {
      fontSize: 12,
    },
    backgroundColor: 'transparent',
  },
};

export const Chart = ({ data, color, onClick }) => {
  const domRef = useChart(
    {
      ...titleOptions(data.name),
      ...OPTIONS,
      color,
      series: [
        {
          data: data.values,
          type: 'bar',
        },
      ],
    },
    onClick,
  );

  return <div className="s-lineup-explorer__chart" ref={domRef} />;
};

Chart.propTypes = {
  data: PropTypes.object.isRequired,
  color: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  onClick: PropTypes.func,
};
